import { z } from "zod";
import { SetPasswordType } from "@/constants/enums";
import { optionalSearch } from "./shared";

export const setPasswordSearchSchema = z.object({
  type: optionalSearch(
    z.enum([SetPasswordType.ResetPassword, SetPasswordType.ActivateAccount]),
  ),
  token: optionalSearch(z.string()),
});

export type SetPasswordSearch = z.infer<typeof setPasswordSearchSchema>;
